import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "@/context/UserContext";

const LOCAL_STORAGE_KEY = "MapViewParameters";

const DEFAULT_FILTERS = {
  search: "",
  definition_uuid: null,
  search_in_selected_definitions: true,
};

export const useFilters = () => {
  const { user } = useContext(UserContext);
  const userUuid = user?.user_uuid;

  const [isReady, setIsReady] = useState(false);

  const [filters, setFilters] = useState(() => {
    if (!userUuid) return DEFAULT_FILTERS;

    try {
      const raw = localStorage.getItem(`${userUuid}_${LOCAL_STORAGE_KEY}`);
      if (!raw) return DEFAULT_FILTERS;

      const parsed = JSON.parse(raw);

      return {
        ...DEFAULT_FILTERS,
        ...parsed?.filters,
      };
    } catch {
      return DEFAULT_FILTERS;
    }
  });

  useEffect(() => {
    if (!userUuid) return;

    try {
      localStorage.setItem(
        `${userUuid}_${LOCAL_STORAGE_KEY}`,
        JSON.stringify({ filters }),
      );
      setIsReady(true);
    } catch {}
  }, [filters, userUuid]);

  const onChangeFilters = useCallback((next) => {
    setFilters((prev) => ({
      ...prev,
      ...next,
    }));
  }, []);

  return { filters, onChangeFilters, isReady };
};

export default useFilters;
